import Model from './Model';

/**
 * @example
 * const Tags = Document.makeModel('/document-templates/trajectory/tags')
 * Tags.collection() // returns all tags usable in trajectory documents
 */
export default class DocumentTemplateTag extends Model {
    name;
    description;

    static apiPath() {
        return 'document-templates/trajectory/tags';
    }
}



// WEBPACK FOOTER //
// ./src/models/DocumentTemplateTag.js